import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ButtonType } from 'src/app/shared/common/components/buttons/button';
import { JobAttachmentChipType } from 'src/app/shared/common/enums/attachments/job-attachment-type';
import { CreatePanelView, DetailPanelView } from 'src/app/shared/common/enums/list-panel/panel-view-mode.enum';
import { PanelMenuService } from 'src/app/shared/common/services/panel-menu/panel-menu.service';
import { JobChipData, SurveyJobAttachment } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'edit-linked-project-files',
    templateUrl: './edit-linked-project-files.component.html'
})
export class EditLinkedProjectFilesComponent implements OnInit, OnChanges {
    @Input() linkedFiles: SurveyJobAttachment[] = [];

    @Output() linkedFilesChange = new EventEmitter<SurveyJobAttachment[]>();

    chipData: JobChipData[] = [];

    ButtonType = ButtonType;
    JobAttachmentChipType = JobAttachmentChipType;

    constructor(private panelMenuService: PanelMenuService) {}

    ngOnInit(): void {
        this.mapToChipData();
    }

    ngOnChanges(): void {
        this.mapToChipData();
    }

    private mapToChipData(): void {
        this.chipData = this.linkedFiles.map(file => ({
            id: file.id?.split(':').pop(),
            label: file.fileName,
            url: file.downloadUrl
        }));
    }

    removeLinkedFile(file: JobChipData): void {
        this.linkedFiles = this.linkedFiles.filter(f => f.id?.split(':').pop() !== file.id);
        this.linkedFilesChange.emit(this.linkedFiles);
        this.mapToChipData();
    }

    toggleAttachFilesPanelView(): void {
        this.panelMenuService.detailsPanelViewStream.next(DetailPanelView.AttachFiles);
        this.panelMenuService.createPanelViewStream.next(CreatePanelView.AttachFiles);
    }
}
